import { grpc } from "@improbable-eng/grpc-web";

import { AuthModule } from "@/store/modules/auth";

export const setAuthorizationHeader = async (metadata: grpc.Metadata) => {
  await AuthModule.getIdToken();
  const token = AuthModule.idToken;
  metadata.set("authorization", `Bearer ${token}`);
  if (AuthModule.isAdminUser) {
    // eslint-disable-next-line
    console.log(token);
  }
};

export const setBoardIdHeader = async (metadata: grpc.Metadata) => {
  if (!AuthModule.currentBoard) return metadata;
  metadata.set("board-id", AuthModule.currentBoard.id);
  if (AuthModule.isAdminUser) {
    metadata.set(
      "customer-id",
      String(AuthModule.currentBoard.data.customerId),
    );
  }
};

export const getMetadata = async () => {
  const metadata = new grpc.Metadata();
  await setAuthorizationHeader(metadata);
  await setBoardIdHeader(metadata);
  return metadata;
};
